import { ComboBox, InputMaskField, TextInput } from '@components';
import { genres, marital } from '@utils';
import { Field } from 'formik';
import React from 'react';

export const DadosPessoais = () => {
  return (
    <div className="card">
      <div className="card-body">
        <h3 className="mb-32 ts-16 fw-bold">Dados de usuário</h3>

        <div className="row">
          <div className="col-md-12 col-lg-6">
            <Field
              name="nome"
              className="mb-3"
              disabled
              component={TextInput}
              label="Nome completo"
            />
            <Field
              name="dtNascimento"
              className="mb-3"
              mask="11/11/1111"
              inputMode="numeric"
              component={InputMaskField}
              label="Data de nascimento"
            />
            <Field
              className="mb-3"
              disabled
              name="cpf"
              mask="111.111.111-11"
              inputMode="numeric"
              component={InputMaskField}
              label="CPF"
            />
            <Field
              name="sexo"
              className="mb-3"
              component={ComboBox}
              label="Gênero"
              options={genres.map((s) => {
                return { value: s, label: s };
              })}
            />
            <Field
              name="nacionalidade"
              className="mb-3"
              component={TextInput}
              label="Nacionalidade"
            />
            <Field
              name="estadoNasc"
              className="mb-3"
              component={TextInput}
              label="Estado de nascimento"
            />
          </div>
          <div className="col-md-12 col-lg-6 mt-md-4 mt-lg-0">
            <Field
              className="mb-3"
              name="rg"
              component={TextInput}
              label="Documento de Identificação (DI)"
            />

            <Field
              name="estadoCivil"
              className="mb-3"
              component={ComboBox}
              label="Estado Civil"
              options={marital.map((s) => {
                return { value: s, label: s };
              })}
            />
            <Field
              name="pai"
              className="mb-3"
              component={TextInput}
              label="Pai"
            />
            <Field
              name="mae"
              className="mb-3"
              component={TextInput}
              label="Mãe"
            />
            <Field
              name="localNascimento"
              className="mb-3"
              component={TextInput}
              label="Local de nascimento"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
